import type { Theme } from "@mui/material/styles";

/**
 * Papel de los globitos del calendario (limpiezas, fuera de servicio): mismo
 * tamaño, radio y sombra para que se lean como una sola familia.
 */
export const calendarPopoverPaperSx = (theme: Theme) => ({
  p: 1.25,
  maxWidth: 260,
  borderRadius: 1.5,
  boxShadow: theme.palette.app.shadow.lg,
});
